import { toggleSupportChat, useSupportChat } from '../lib/support';
import '../styles/support-button.scss';

/**
 * The header's entry point to support chat.
 *
 * Exists so the Zendesk launcher does not have to: the corner bubble is hidden
 * the moment the widget loads and this is the only way in, which keeps the
 * streaming view's bottom-right corner — where AppStream puts its own controls —
 * clear.
 */
export function SupportButton() {
  const { available, open } = useSupportChat();

  // Nothing to toggle when support chat is switched off for the environment, or
  // when the snippet never loaded. A button that opens nothing is worse than no
  // button, so this renders as if the feature does not exist.
  if (!available) return null;

  return (
    <button
      type="button"
      className={`x5-support${open ? ' x5-support--on' : ''}`}
      // A toggle, not a link: aria-pressed is what tells a screen reader the
      // panel is already open, since the label does not change.
      aria-pressed={open}
      aria-label="Support chat"
      onClick={toggleSupportChat}
    >
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="1.8" />
        <path
          d="M9.2 9.3a2.9 2.9 0 0 1 5.6 1c0 1.9-2.8 2.5-2.8 4"
          stroke="currentColor"
          strokeWidth="1.8"
          strokeLinecap="round"
        />
        <circle cx="12" cy="17.2" r="1.05" fill="currentColor" />
      </svg>
      <span className="x5-support__label">Support</span>
    </button>
  );
}
